module.exports = __webpack_public_path__ + "images/emoji/fire_engine.510489b5b5294ec00ee5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fire_engine.png
// module id = +Z5E
// module chunks = 14